export enum CertificateDownloadFormat {
  JPEG     = 1,
  PNG      = 2,
  WebPDF   = 3,
  PrintPDF = 4
}